module.exports = __webpack_public_path__ + "static/our-mission-1-a3f1355be12403ba6d40e3d8987ef51e.jpg";